import type { ComboboxItem } from '@reelplicate/ui';

/** "GMT+1", "GMT-4", "GMT" - the zone's current offset, for labels. */
export function zoneOffset(timeZone: string, now: Date) {
  const part = new Intl.DateTimeFormat('en-GB', { timeZone, timeZoneName: 'shortOffset' })
    .formatToParts(now)
    .find((p) => p.type === 'timeZoneName');
  return part?.value ?? '';
}

/** Every IANA timezone the browser knows, as "Europe/London (GMT+1)". */
export function timezoneOptions(now = new Date()): ComboboxItem[] {
  const zones =
    typeof Intl.supportedValuesOf === 'function'
      ? Intl.supportedValuesOf('timeZone')
      : ['UTC', 'Europe/London', 'America/New_York'];
  // UTC isn't always in the list, but it's the API's default.
  return [...new Set(['UTC', ...zones])].map((zone) => ({
    value: zone,
    label: `${zone.replaceAll('_', ' ')} (${zoneOffset(zone, now)})`,
    keywords: [zone],
  }));
}

/** The browser's timezone, sent when a workspace is created. */
export const browserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
